export const WINTER_SPORTS_ADDON_ID = '08050'
export const COVID_ADDON_ID = '08054'
export const CYBER_ADDON_ID = '16001'
